import { useState } from 'react';
import { ClockCounterClockwise, Trash } from '@phosphor-icons/react';
import { BestaetigenDialog, InnenKarte, LeerZustand, ToastPill, useToastPill } from '../../../../../components/immobilien/ui';
import { deDatum, ehemaligeMieter, type EhemaligerMieter } from '../../../../../lib/immobilien/objektDetail';
import { initialen } from '../../../../../lib/immobilien/format';
import { useOpenKontakt } from '../../../../../lib/immobilien/openKontakt';
import { loescheMieter } from '../../../../../lib/mieter/loeschen';
import { useObjektSeite } from '../ObjektSeitenKontext';

/** Panel „Ehemalige Mieter“: ausgezogene Mieter, Klick öffnet den Kontakt, endgültig löschen wie bisher. */
export function EhemaligePanel() {
  const { daten, neuLaden } = useObjektSeite();
  const openKontakt = useOpenKontakt();
  const [toast, zeige] = useToastPill();
  const [loeschen, setLoeschen] = useState<EhemaligerMieter | null>(null);
  const [laeuft, setLaeuft] = useState(false);
  const liste = ehemaligeMieter(daten.mieter, daten.einheiten);

  const bestaetige = async () => {
    if (!loeschen) return;
    setLaeuft(true);
    try {
      await loescheMieter(loeschen.id);
      zeige(`${loeschen.name} gelöscht`);
      setLoeschen(null);
      neuLaden('mieter');
    } catch (e) {
      zeige(`Löschen fehlgeschlagen: ${e instanceof Error ? e.message : 'Unbekannt'}`, true);
    } finally {
      setLaeuft(false);
    }
  };

  if (liste.length === 0) return <LeerZustand icon={ClockCounterClockwise} titel="Keine ehemaligen Mieter" text="Ausgezogene Mieter erscheinen hier mit Mietzeitraum." />;

  return (
    <>
      {toast && <ToastPill text={toast.text} fehler={toast.fehler} />}
      <InnenKarte padding={8} gap={2}>
        {liste.map(m => (
          <div key={m.id} className="immo-hover-flaeche flex items-center" style={{ gap: 12, padding: '10px 10px', borderRadius: 16 }}>
            <span className="flex items-center justify-center shrink-0" style={{ width: 40, height: 40, borderRadius: '50%', background: 'var(--fill2)', fontSize: 13, fontWeight: 700, color: 'var(--ink2)' }}>{initialen(m.name)}</span>
            <button type="button" onClick={() => openKontakt(m.id, 'mieter')} className="flex flex-col flex-1 min-w-0 text-left cursor-pointer" style={{ border: 'none', background: 'transparent', padding: 0, color: 'var(--ink)' }}>
              <span className="truncate" style={{ fontSize: 14, fontWeight: 700 }}>{m.name}</span>
              <span className="truncate" style={{ fontSize: 12, color: 'var(--ink3)' }}>{m.einheit} · {m.von || m.bis ? `${deDatum(m.von)} – ${deDatum(m.bis)}` : 'Zeitraum unbekannt'}</span>
            </button>
            <button type="button" aria-label={`${m.name} endgültig löschen`} title="Endgültig löschen" onClick={() => setLoeschen(m)}
              className="flex items-center justify-center cursor-pointer" style={{ width: 34, height: 34, borderRadius: '50%', border: 'none', background: 'transparent', color: 'var(--ink3)' }}>
              <Trash size={16} />
            </button>
          </div>
        ))}
      </InnenKarte>
      {loeschen && (
        <BestaetigenDialog
          titel="Mieter endgültig löschen?"
          text="Das kann nicht rückgängig gemacht werden."
          detail={<>„{loeschen.name}“ wird gelöscht. Die diesem Mieter zugeordneten Dokumente werden mitgelöscht.</>}
          bestaetigenLabel="Endgültig löschen"
          laeuft={laeuft}
          onBestaetigen={() => { void bestaetige(); }}
          onAbbrechen={() => setLoeschen(null)}
        />
      )}
    </>
  );
}
